import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from 'antd';
import facility_icon from 'assets/facility_icon.svg';
import provider_icon from 'assets/provider_icon.svg';
import React from 'react';
var EntityIcon = function (_a) {
    var isFacility = _a.isFacility;
    return (_jsx(Avatar, { alt: "".concat(isFacility ? 'Facility' : 'Provider', " Care Plan"), size: 55, src: isFacility ? facility_icon : provider_icon, shape: "square", style: { backgroundColor: '#E2EEFF', padding: isFacility ? 11 : 13 } }));
};
export default EntityIcon;
